import { Button, Collapse, Group, ScrollArea, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconAlertTriangle } from '@tabler/icons-react';

import { ChatMessage } from '#components/chat/messages/ChatMessage';
import type { ChatCompletionMessage } from '#components/chat/types';

export interface ChatErrorMessageProps {
  role?: ChatCompletionMessage['role'];
  name?: string;
  message?: string;
  details?: string;
}

export function ChatErrorMessage({
  role = 'assistant',
  name = 'Error',
  message,
  details,
  children,
}: React.PropsWithChildren<ChatErrorMessageProps>) {
  const [opened, { toggle }] = useDisclosure(false);
  return (
    <ChatMessage role={role} kind="error">
      <Group gap="xs">
        <IconAlertTriangle size={16} />
        <Text fz="xs" tt="uppercase" fw="bold">
          {name}
        </Text>
        {message && (
          <Text fz="xs" tt="uppercase">
            {message}
          </Text>
        )}

        {details && (
          <Button variant="light" size="xs" onClick={toggle} color="white" ml="auto">
            Show details
          </Button>
        )}
      </Group>

      {details && (
        <Collapse in={opened}>
          <ScrollArea.Autosize mah={200} p="xs" bg="red.9">
            <Text size="xs">{details}</Text>
          </ScrollArea.Autosize>
        </Collapse>
      )}

      {children}
    </ChatMessage>
  );
}
